import { ArrowRight, Prohibit } from "@phosphor-icons/react";

type Props = {
	errorCount: number;
	continueDisabled: boolean;
	onErrorClick: () => void;
	onContinueClick: () => void;
};

const BottomActionBar = ({ errorCount, continueDisabled, onErrorClick, onContinueClick }: Props) => {
	const hasErrors = errorCount > 0;

	return (
		<div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3">
			<div className="flex gap-3">
				<button
					onClick={onErrorClick}
					disabled={!hasErrors}
					className={`flex items-center justify-center gap-1.5 px-4 py-3 rounded-xl text-sm font-medium transition whitespace-nowrap ${
						hasErrors
							? "bg-red-600 text-white"
							: "bg-red-50 text-red-300 cursor-not-allowed"
					}`}>
					<Prohibit size={14} />
					{errorCount} Error{errorCount !== 1 && "s"}
				</button>
				
				<button
					onClick={onContinueClick}
					disabled={continueDisabled}
					className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-medium transition border border-[#4E45C4]
               bg-gradient-to-b from-[#554FB0] to-[#332D96] text-white ${
					continueDisabled ? "cursor-not-allowed opacity-60" : ""
				}`}>
					Continue <ArrowRight size={16} />
				</button>
			</div>
		</div>
	);
};

export default BottomActionBar;